import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    gpxPoints: [], // Full GPX point data with elevation, time, etc.
    gpxCoordinates: [], // Coordinates only (for backward compatibility)
    snappedCoordinates: [],
    mapCenter: null,
    error: '',
    isSnapped: false, // Track if snap to roads has been called
  },
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    resetSnappedData(state) {
      state.data.snappedCoordinates = [];
      state.data.isSnapped = false;
    },
  },
});

export const { setData, resetSnappedData } = mapSlice.actions;
export default mapSlice.reducer;
